import Header from "@commons/header";
import Column from "@components/column";
import { GalleryHorizontalEnd } from "lucide-react";
import BannerForm from "./form";
import BannerList from "./list";

const BannerSetup = () => {
  return (
    <Column>
      <Header title="Banner Setup" icon={GalleryHorizontalEnd} />
      <BannerForm />
      <BannerList />
    </Column>
  );
};

export default BannerSetup;
